import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ypzb8z9d5: FaireProductEntity = {
  token: "p_7ypzb8z9d5",
  type: "product",
  name: "Linen Roso Cushion Cover",
  brandToken: "b_4uyrnv7cr8",
  brandName: "Live Linen",
  imageUrl:
    "https://cdn.faire.com/fastly/2451e9f4a2dc292371e08f07713b6dbde5091eb1fc89e29b52f379d54d9eb126.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd3446f12be893909fcaf5f93add0c4e5e560f6ca090f1971ffe3ea686fb71c5.jpeg",
    "https://cdn.faire.com/fastly/c147ea7cc21d41f7a2ee8a9a71b43d1a852c91a89dde56650f34586fdd7e471a.jpeg",
    "https://cdn.faire.com/fastly/2c314acfd59096c9d6af3376bbc7ebe2d87a8f227585564d1560687455250610.jpeg",
    "https://cdn.faire.com/fastly/8decde77532a1edb6b6b58942f35b43088333a42a5974aea8fce35711d2d422b.jpeg",
    "https://cdn.faire.com/fastly/859cb7c483c3e0330bd550697a60e9987ab473485edfe0ec7231b9f0e0f420c8.jpeg",
  ],
  priceDollars: 14,
  description:
    "Add a subtle pop of warmth with Linen Roso Cushion Cover – Orange Stripe  Made from premium yarn-dyed European linen, this design showcases soft orange stripes woven using traditional techniques. Naturally breathable and durable, the fabric softens with every wash, creating a lived-in feel while retaining its classic character.\n. OEKO-TEX Certified\n. European Flax Certified\n. Washed for Maximum Softness\n\nIncludes One Cushion Cover\nMade from 100% European Linen",
  tags: [],
  msrpDollars: 43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:10:58.576Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
